export default __webpack_public_path__ + "static/media/extruder-up.92f6a8dc.svg";